import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Input } from "sr/helpers";

type Props = {
  data: { area?: string };
  HandleDataProps: (payload: { area: string }) => void;
  externalErrorId?: string;
};

const RequirementAreaChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [area, setArea] = useState("");
  const [errorId, setErrorId] = useState<string>("");

  useEffect(() => {
    setArea(data?.area || "");
  }, [data?.area]);

  useEffect(() => {
    HandleDataProps({ area });
  }, [area]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!area?.trim()) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.AREA');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => ({ area }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Area</p>
      <Input
        name="area"
        value={area}
        onChange={(e: any) => setArea(e.target.value)}
        error={externalErrorId || errorId}
        placeholder="Enter area details"
      />
    </div>
  );
});

export default RequirementAreaChange;
